import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Mechanism() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-6 bg-brand-charcoal text-white" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <FadeIn data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-brand-bg" data-id="element-209">
            Lo que realmente ocurre en el cerebro de tu hijo durante un
            berrinche
          </h2>
          <p className="text-center text-gray-400 mb-12 text-lg" data-id="element-210">
            Esto lo cambia todo.
          </p>
        </FadeIn>

        {/* Brain Diagram */}
        <FadeIn delay={0.1} data-id="element-211">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-16" data-id="element-212">
            <h3 className="text-2xl font-bold text-center mb-8 text-brand-bg" data-id="element-213">
              CEREBRO DEL NIÑO EN BERRINCHE
            </h3>
            <div className="space-y-4" data-id="element-214">
              {[{
              label: '🧠 Cerebro racional',
              status: '❌ APAGADO',
              color: 'text-red-400'
            }, {
              label: '🚨 Sistema de alarma',
              status: '🔴 AL MÁXIMO',
              color: 'text-red-400'
            }, {
              label: '👂 Capacidad de escuchar',
              status: '❌ BLOQUEADA',
              color: 'text-red-400'
            }, {
              label: '🤝 Capacidad de cooperar',
              status: '❌ INACCESIBLE',
              color: 'text-red-400'
            }].map((item, index) => <div key={index} className="flex items-center justify-between p-4 bg-white/5 rounded-xl" data-id="element-215">
                  <span className="text-lg text-gray-300" data-id="element-216">{item.label}</span>
                  <span className={`text-lg font-bold ${item.color}`} data-id="element-217">
                    {item.status}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-218">
          <div className="text-center space-y-4 mb-16 text-lg text-gray-300" data-id="element-219">
            <p data-id="element-220">En ese estado tu hijo no puede escuchar tu explicación.</p>
            <p data-id="element-221">No puede procesar tu amenaza.</p>
            <p data-id="element-222">No puede razonar con tu soborno.</p>
            <p className="text-xl text-white font-medium pt-4" data-id="element-223">
              Está atrapado en una tormenta eléctrica emocional que su cuerpo
              todavía no sabe manejar solo.
            </p>
          </div>
        </FadeIn>

        {/* The Key Point */}
        <FadeIn data-id="element-224">
          <div className="bg-brand-sage p-8 md:p-10 rounded-3xl text-brand-bg shadow-2xl mb-16" data-id="element-225">
            <h3 className="text-2xl font-serif font-bold mb-6 text-center" data-id="element-226">
              EL PUNTO QUE LO CAMBIA TODO
            </h3>
            <p className="text-xl mb-8 leading-relaxed text-center" data-id="element-227">
              Los niños no aprenden a regularse solos.
              <br data-id="element-228" />
              <br data-id="element-229" />
              Aprenden tomando prestada la calma del adulto que tienen al
              frente.
            </p>

            {/* Mirror Diagram */}
            <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-230">
              <div className="bg-red-100 text-red-900 p-6 rounded-2xl" data-id="element-231">
                <p className="text-xl font-bold mb-3 text-center" data-id="element-232">
                  TÚ SUBES 🔺
                </p>
                <p className="text-center mb-2" data-id="element-233">Él sube MÁS 🔺</p>
                <p className="text-center font-medium" data-id="element-234">Crisis escala</p>
              </div>
              <div className="bg-green-100 text-green-900 p-6 rounded-2xl" data-id="element-235">
                <p className="text-xl font-bold mb-3 text-center" data-id="element-236">
                  TÚ BAJAS 🔽
                </p>
                <p className="text-center mb-2" data-id="element-237">Él empieza a bajar también</p>
                <p className="text-center font-medium" data-id="element-238">Crisis se corta</p>
              </div>
            </div>

            <p className="text-2xl font-serif font-bold text-center mb-2" data-id="element-239">
              A esto lo llamamos el{' '}
              <span className="text-brand-orange-hover" data-id="element-240">
                Método Espejo Rápido
              </span>
              .
            </p>
            <p className="text-center text-lg opacity-90 mb-8" data-id="element-241">
              No es magia. Es neurología básica aplicada al momento más caótico
              del día.
            </p>

            <div className="space-y-3" data-id="element-242">
              <div className="flex items-center gap-3 bg-white/20 p-4 rounded-xl" data-id="element-243">
                <span className="text-2xl" data-id="element-244">✅</span>
                <span className="text-lg" data-id="element-245">Se puede aprender en una tarde.</span>
              </div>
              <div className="flex items-center gap-3 bg-white/20 p-4 rounded-xl" data-id="element-246">
                <span className="text-2xl" data-id="element-247">✅</span>
                <span className="text-lg" data-id="element-248">
                  Se puede aplicar esa misma noche.
                </span>
              </div>
              <div className="flex items-center gap-3 bg-white/20 p-4 rounded-xl" data-id="element-249">
                <span className="text-2xl" data-id="element-250">✅</span>
                <span className="text-lg" data-id="element-251">Funciona aunque estés agotado.</span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* CTA #2 - Intermediate */}
        <FadeIn data-id="element-252">
          <div className="text-center" data-id="element-253">
            <Button onClick={scrollToPricing} className="mb-4" data-id="element-254">
              👉 QUIERO APRENDER EL MÉTODO AHORA
            </Button>
            <p className="text-sm text-gray-400" data-id="element-255">
              Acceso inmediato por solo $9.99
              <br data-id="element-256" />
              🛡️ Garantía de 7 días sin preguntas
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}